import React from 'react';

// Loading padrão das tabelas de busca (mesmo comportamento da tela de Eventos).
// O spinner fica centralizado na área VISÍVEL da tabela, mesmo quando ela é mais larga
// que a tela e tem scroll horizontal. A centralização depende do `container-type` no
// wrapper da tabela (.table-responsive / .fin-pp__tblwrap) — ver src/css/tabela-loading.css.
const TabelaLoading = ({ texto = 'Buscando...' }) => (
    <div className="tabela-msg">
        <span className="fin-pp__spin" role="status" />
        <span>{texto}</span>
    </div>
);

export default TabelaLoading;
